import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faYoutube, faTelegramPlane } from '@fortawesome/free-brands-svg-icons';
import ScrollToTopButton from '../pages/ScrollToTopButton';
import '../../assets/css/style.css';
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const Distance = () => {
  return (
    <div>
      <div className='distance'>
        <div className="sidebar-page-container">
          <div className="auto-container">
            <div className="row">
              <div className="content-side col-xl-9 col-lg-8 order-lg-2">
                <div className="services-single">
                  <div className="inner-box">
                 
                    <div className='sec-title'>
                      <h3 style={{ textAlign: 'center' }}>COLLEGE OF DISTANCE EDUCATION</h3>
						<UnderlineWithIcon/>
                    </div>
                    <div className="text">
                      <p>
                        Admas University, through its College of Distance Education, is committed to addressing the evolving educational needs of society by offering flexible and accessible learning opportunities. To meet the rising demand for highly qualified professionals, the university provides postgraduate programs in Business Management, Agricultural Economics, Educational Planning and Management, Marketing Management, Economics, Rural Development & Agricultural Extension, and Accounting and Finance across the country.
                      </p>
                      <p>
                        Over the years, the university has contributed to the development of skilled and ethically grounded graduates who hold key positions in the civil service and private sectors. Recognizing their need for further academic advancement, Admas University has established a system that delivers affordable, relevant, and high-quality distance education, ensuring students can achieve their academic and professional aspirations without geographical limitations.
                      </p>
                    </div>

                    <div className="facts">
                      <h3 style={{ textAlign: 'center' }}>ADMISSION CRITERIA</h3>
                      <p>To be eligible for admission to our university, applicants must meet the following criteria:</p>
                    </div>
<div className="admission-criteria" style={{ marginLeft: '20px' }}>
      <h4>Admission Criteria for BA/BSc Degree at Admas University</h4>
      <p>
        Applicants for admission to the BA/BSc degree at Admas University (AdU) must satisfy one or more of the following criteria:
      </p>

      <h5>1. After Successful Completion of Grade 12 or Preparatory Program:</h5>
      <ul className="services-list">
          <li><div className="icon-box"><span className="flaticon-book"></span>Meet the cut-off points set by the Ministry of Education.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Comply with the Senate legislation of the University.</div></li>
      </ul>

      <h5>2. After Completion of Diploma (10+3 or 12+2) or TVET Level IV in Related Fields:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>Hold a diploma (10+3 or 12+2) or TVET Level IV certification from a recognized institution.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Certification by the Center of Competency established by the TVET Regional Bureau of Labor and Skills.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Possess two years of relevant work experience in the qualification area.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Pass the entrance examination prepared by the department(s).</div></li>
      </ul>

      <h5>3. After Having a First Degree:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>BA, BSc, or higher degree certification from a recognized institution in any profession, supported by an official transcript.</div></li>
       <li><div className="icon-box"><span className="flaticon-book"></span>Meet the admission criteria set by the University.</div></li>
      </ul>

      <h5>4. For Foreign Students:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>BA, BSc, or higher degree certification from a recognized institution.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Certificates equivalence meeting Ethiopian Ministry of Education standards, approved and authenticated by the Ethiopian Transnational Authority (ETA).</div></li>
      </ul>

      <h5>5. Student Transfer:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>Transfer from a recognized University in the same field of study.</div></li>
      </ul>

      <h5>6. In Cases of High Competition for Admission:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>Grade 12 university entrance examination result and completion year.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Grade point average at graduation.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>Additional training after graduation.</div></li>
    <li><div className="icon-box"><span className="flaticon-book"></span>Work experience and a supporting letter from the respective employer.</div></li>
       <li><div className="icon-box"><span className="flaticon-book"></span>The entrance examination result will be considered in candidate selection.</div></li>
      </ul>

      <h5>Minimum Requirements for Admission to All Degree Programs:</h5>
      <ul className="services-list">
        <li><div className="icon-box"><span className="flaticon-book"></span>Successful completion of a two-year preparatory program with the minimum University Entrance Examination results set by the Ministry of Education.</div></li>
       <li><div className="icon-box"><span className="flaticon-book"></span>Completion of a Diploma program (12+2, 10+3, Level IV) with two years of relevant work experience and Center of Competency certification, passing the University’s entrance examination.</div></li>
       <li><div className="icon-box"><span className="flaticon-book"></span>A degree program student from other accredited Higher Education Institutions who withdrew for non-academic reasons.</div></li>
        <li><div className="icon-box"><span className="flaticon-book"></span>A first-degree graduate in any field of study from accredited Higher Education Institutions.</div></li>
      </ul>

      <p>
        <strong>Note:</strong> Minimum requirements may be scaled up in cases of high competition for admission or as determined by the University Senate.
      </p>
    </div>
   
                  </div>
                </div>
              </div>

              <div className="sidebar-side col-xl-3 col-lg-4">
                <aside className="sidebar">
                  <div className="sidebar-widget sidebar-blog-category">
                    <ul className="blog-cat">
                      <li className="active"><a href="performance-upgrade.html">Admas University Distance Education Campuses</a></li>
                      <li><a href="/dmekanissa">Mekanissa (Main Center)</a></li>
                      <li><a href="/adwa">Adwa</a></li>
                      <li><a href="/assosa">Assosa</a></li>
                      <li><a href="/axum">Axum</a></li>
                      <li><a href="/bahirdar">Bahirdar</a></li>
                      <li><a href="/bishoftu">Bishoftu</a></li>
                      <li><a href="/debrebirhan">Debrebirhan</a></li>
                      <li><a href="/dessie">Dessie</a></li>
                      <li><a href="/harar">Harar</a></li>
                      <li><a href="/hawassa">Hawassa</a></li>
                      <li><a href="/jigjiga">Jigjiga</a></li>
                      <li><a href="/jimma">Jimma</a></li>
                      <li><a href="/logia">Logia</a></li>
                      <li><a href="/mekelle">Mekelle</a></li>
                      <li><a href="/gondar">Gondar</a></li>
					  <li><a href="/worota">Worota</a></li>
                      <li><a href="/meskel-square">Meskel Square (Addis Ababa)</a></li>
                    </ul>
                  </div>

                  <div className="sidebar-widget contact-info-widget">
                    <div className="sidebar-title style-two">
                      <h2>Contact Us</h2>
                    </div>
                    <div className="inner-box">
                      <ul>
                        <li><span className="icon fas fa-phone"></span>+2510116687671</li>
                        <li>
                          <a href="https://t.me/AdmasAA" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <FontAwesomeIcon icon={faTelegramPlane} /> Join Us
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default Distance;